"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Linkedin, Twitter, Facebook, Instagram, ShieldCheck } from "lucide-react";
const services = ["Creative Finance Strategies", "Hybrid Annuities & Pensions", "Modern Life Insurance", "Living Benefits Riders", "Financial Literacy"];
const socialLinks = [{
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-sm text-muted-foreground hover:text-primary transition-colors">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/CreativeWealthPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">Creative Wealth</Link>
        </li>
        <li data-index={2}>
          <Link to="/LifeInsurancePage" className="text-sm text-muted-foreground hover:text-primary transition-colors">Life Insurance</Link>
        </li>
        <li data-index={3}>
          <Link to="/ContactPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">Contact</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function AgencyFooter() {
  return <footer id="agency-footer" className="dark bg-black text-foreground border-t border-primary">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-8">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          
          {}
          <div className="flex flex-col items-center text-center">
            <Link to="/HomePage" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1593423/img/image_evl6fyfx.png" alt="FTG Financial & Insurance Services, LLC. Logo" className="h-[120px] w-auto object-contain" />
            </Link>
            <p className="text-base leading-relaxed text-muted-foreground">
              Specializing in Creative Finance and modern Life Insurance solutions. We build wealth in non-traditional formats, offering a three-dimensional outlook on your financial future.
            </p>
          </div>

          {}
          <div className="text-center">
            <h3 className="mb-6 font-serif text-xl font-medium tracking-wide text-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="48">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="text-center">
            <h3 className="mb-6 font-serif text-xl font-medium tracking-wide text-foreground">
              Strategies
            </h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/CreativeWealthPage" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="text-center">
            <h3 className="mb-6 font-serif text-xl font-medium tracking-wide text-foreground">
              Connect With Us
            </h3>
            <ul className="mb-8 space-y-6 text-base text-muted-foreground">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 size-4 shrink-0 text-primary" />
                <span>
                  3333 Michelson Dr. Suite 300<br />
                  Irvine, CA 92612
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-primary" />
                <span>(949) 346-4434</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-primary" />
                <span>admin@ftgfin.com</span>
              </li>
              <li className="flex items-center gap-3">
                <ShieldCheck className="size-4 shrink-0 text-primary" />
                <span>CA Insurance License: 6010787</span>
              </li>
            </ul>
            
            <div className="flex items-center justify-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} data-index={i} className="group rounded-full border border-border bg-card p-3 transition-colors hover:border-primary hover:bg-primary/10" aria-label={social.label}>
                    <Icon className="size-5 text-muted-foreground transition-colors group-hover:text-primary" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="my-12 h-0.5 bg-border" />

        {}
        <div className="flex flex-col items-center justify-between gap-6 text-center md:flex-row md:text-center">
          <p className="text-sm text-muted-foreground/70">© 2026 FTG Financial &amp; Insurance Services, LLC. All rights reserved.</p>
          <p className="max-w-3xl text-sm leading-relaxed text-muted-foreground/50">
            Information presented is for educational purposes only and does not intend to make an offer or solicitation for the sale or purchase of any specific securities, investments, or investment strategies. Investments involve risk and, unless otherwise stated, are not guaranteed.
          </p>
        </div>
      </div>
    </footer>;
}